import Baseurl from "../Baseurl/Baseurl";


const LoginApi=(data)=>Baseurl.post("/login/verify",data);

export default LoginApi;